<script lang="ts">
	import { readDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Services
	import { postReq } from '../../../../../services/http';
	import { format } from '../../../../../services/i18n';

	//Stores

	//Types
	import type { SettingRequest } from '../../../../../types/requests/settings/setting';
	import type { Device } from '../../../../../types/Device';
	import type { InputClickEvent } from '../../../../../types/InputClickEvent';

	//Helpers
	import { onSettingsResponse } from '../../../../../helpers/device_settings_helpers';

	//Design system components
	import { Toggle, Alert } from '@Shelly/shelly-design-system';
	export let device: Device;

	const settings = readDeviceSettings(device.id);
	let enabled = settings.clog_prevention;
	let loading = false;

	const sendRequest = async (e: InputClickEvent): Promise<void> => {
		loading = true;
		enabled = e.target.checked;
		const res: SettingRequest = await postReq(
			`/device/generic_command`,
			{
				id: device.id,
				command: `clog_prevention`,
				payload: JSON.stringify({
					enabled,
				}),
			},
			20000,
		);

		if (!res?.isok) {
			enabled = !enabled;
		}

		onSettingsResponse(res, device);
		loading = false;
	};
</script>

<Toggle
	class="mb-s"
	size="m"
	disabled={loading}
	on:click={sendRequest}
	checked={enabled}
	id="toggle-9db0a0v"
>
	{$format('enable', { default: 'Enable' })}
</Toggle>

<Alert
	heading={$format('clog_description', {
		default:
			'If enabled, valve will ensure there is at least one movement in a week to prevent clogging.',
	})}
/>
